import React, { useState } from 'react';
import Modal from '../Modal';
import NewInspectionForm from '../NewInspectionForm';
import StandardInspectionForm from '../StandardInspectionForm';
import './InspectionFormModal.css';
import { ROLES } from '../../utils/constants';
import { useAuthContext } from '../../context/AuthContext';

const InspectionFormModal = ({ isOpen, onClose, onInspectionCreated }) => {
    const [selectedType, setSelectedType] = useState('');

    const { currentUser } = useAuthContext();
    const isAdmin = [ROLES.ADMINISTRATOR, ROLES.CREATOR_SENIOR].includes(currentUser.role);

    const inspectionTypes = [
        { value: '', label: 'Seleccione una opción' },
        ...(isAdmin ? [
            { value: 'INS', label: 'Inspección Digital de Vehículo' },
            { value: 'INS', label: 'Inspección a Domicilio' },
        ] : []),
        { value: 'DIC', label: 'Módulo de Dictamen Técnico Legal' },
    ];

    const handleTypeChange = (type) => {
        setSelectedType(type);
    };

    const handleClose = () => {
        setSelectedType('');
        onClose();
    };

    const handleInspectionCreated = (result) => {
        setSelectedType('');
        if (onInspectionCreated) {
            onInspectionCreated(result);
        }
    };

    const renderForm = () => {
        if (selectedType === 'DIC') {
            return (
                <NewInspectionForm
                    onSubmit={(formData) => {}}
                    onInspectionCreated={handleInspectionCreated}
                    onCancel={handleClose}
                    onClose={handleClose}
                />
            );
        } else if (selectedType === 'INS') {
            return (
                <StandardInspectionForm
                    onSubmit={(formData) => {}}
                    onInspectionCreated={handleInspectionCreated}
                    onCancel={handleClose}
                    onClose={handleClose}
                />
            );
        }
        return null;
    };

    const getModalSize = () => {
        if (selectedType === 'INS') {
            return 'extra-large';
        }
        return 'large';
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleClose}
            size={getModalSize()}
            showCloseButton={true}
            closeOnBackdropClick={false}
        >
            <div className="inspection-form-modal">
                {/* Tipo de Inspección */}
                <div className="inspection-type-section">
                    <h2>Seleccione el tipo de inspección a realizar</h2>
                    <div className="type-selection">
                        <select
                            value={selectedType}
                            onChange={(e) => handleTypeChange(e.target.value)}
                            className="type-dropdown"
                        >
                            {inspectionTypes.map(type => (
                                <option key={type.value} value={type.value}>
                                    {type.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Formulario correspondiente */}
                {selectedType && (
                    <div className="form-section">
                        {renderForm()}
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default InspectionFormModal;